import { languageObserver } from '@aab/utilities';
import { language } from './language';

let translationsPath = '';
const instances = [];
const translations = {};
// only the ISO lang values that we support: nl, nl-NL, en, en-GB.
const validLangRegexp = /^(nl(-NL)?|en(-GB)?)$/;

const translate = (key) => {
  const lang = language();
  if (translations[lang]) {
    return typeof translations[lang][key] !== 'undefined' ? translations[lang][key] : key;
  }
  return key;
};

const setTranslations = (keys) => {
  Object.assign(translations, keys);
};

const setTranslationsPath = (path) => {
  translationsPath = path;
};

const loadTranslations = () => {
  const lang = language();

  if (!translations[lang]) {
    if (!validLangRegexp.test(lang)) { return; }
    const jsonPath = `${translationsPath}/translations/${lang}.json`;
    return fetch(jsonPath)
      .then((response) => response.json())
      .then((data) => { translations[lang] = data; return data; });
  }
  return Promise.resolve(translations[lang]);
};

const languageChanged = () => {
  loadTranslations()?.then(() => {
    instances.forEach((instance) => instance.requestUpdate());
  });
};

const TranslateMixin = (baseClass) => class extends baseClass {
  constructor(keys = {}) {
    super();
    setTranslations(keys);

    try {
      // eslint-disable-next-line camelcase, no-undef
      setTranslationsPath(__webpack_public_path__);
    } catch (e) {
      // No action needed
    }
  }

  connectedCallback() {
    super.connectedCallback();
    if (instances.length === 0) {
      languageObserver.onLanguageChange(languageChanged);
    }
    instances.push(this);

    loadTranslations()?.then(() => this.requestUpdate());
  }

  disconnectedCallback() {
    instances.splice(instances.findIndex((i) => i === this), 1);
    super.disconnectedCallback();
  }
};

export {
  translate,
  setTranslations,
  setTranslationsPath,
  loadTranslations,
  TranslateMixin,
};
